"use client";

import { c as _c } from "react/compiler-runtime";
import { useBusinessVariables } from "@grupa-pracuj/business-variables";
import { CookieAgreements, configureTcfManager, getConfig as getCookiesConfig, type TrackerData } from "@grupa-pracuj/cookies-library-sip";
import { Footer, getConfig as getFooterConfig } from "@grupa-pracuj/footer-library-sip";
import { useGatewayContext } from "@grupa-pracuj/gateway-library-sip";
import { Header } from "@grupa-pracuj/header-library-sip";
import { useSearchParams } from "next/navigation";
import { type ComponentProps, type ReactNode, useEffect, useState } from "react";
import { useTracker } from "@/tracker";
import styles from "./HomeContent.module.css";
type User = ComponentProps<typeof Header>["user"];
configureTcfManager({
  cmpId: Number(process.env.NEXT_PUBLIC_TCF_CMP_ID),
  cmpVersion: Number(process.env.NEXT_PUBLIC_TCF_CMP_VERSION),
  cookieDomain: process.env.COOKIE_DOMAIN ?? "",
  vendorListUrl: process.env.NEXT_PUBLIC_GVL_VENDOR_LIST_URL ?? "",
  purposesUrl: process.env.NEXT_PUBLIC_GVL_PURPOSES_URL ?? ""
});
const HomeContent = t0 => {
  const $ = _c(36);
  const {
    children,
    user
  } = t0;
  const http = useGatewayContext();
  const searchParams = useSearchParams();
  const businessVariables = useBusinessVariables();
  const [forceOpenCookieAgreement, setForceOpenCookieAgreement] = useState(false);
  const {
    analyticsInstance,
    sendBaseAnalytics,
    sendCookieAgreementsModal
  } = useTracker();
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams.get("year") ?? "";
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const year = t1;
  let t2;
  if ($[2] !== searchParams) {
    t2 = searchParams.get("month") ?? "";
    $[2] = searchParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const month = t2;
  let t3;
  if ($[4] !== searchParams) {
    t3 = searchParams.get("pageNumber") ?? "";
    $[4] = searchParams;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const pageNumber = t3;
  const routeChangeKey = `${year}-${month}-${pageNumber}`;
  let t4;
  let t5;
  if ($[6] !== routeChangeKey || $[7] !== sendBaseAnalytics) {
    t4 = () => {
      const trackBaseAnalytics = async _routeKey => {
        await sendBaseAnalytics();
      };
      trackBaseAnalytics(routeChangeKey).catch(_temp);
    };
    t5 = [sendBaseAnalytics, routeChangeKey];
    $[6] = routeChangeKey;
    $[7] = sendBaseAnalytics;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== sendCookieAgreementsModal) {
    t6 = async data => {
      await sendCookieAgreementsModal(data);
    };
    $[10] = sendCookieAgreementsModal;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const handleCookieTrackerEvent = t6;
  let t7;
  if ($[12] !== analyticsInstance || $[13] !== businessVariables || $[14] !== http || $[15] !== user) {
    t7 = <Header businessVariables={businessVariables} http={http} analytics={analyticsInstance} user={user} />;
    $[12] = analyticsInstance;
    $[13] = businessVariables;
    $[14] = http;
    $[15] = user;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== children) {
    t8 = <main className={styles.main}>{children}</main>;
    $[17] = children;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setForceOpenCookieAgreement(false);
    };
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== forceOpenCookieAgreement || $[21] !== handleCookieTrackerEvent) {
    t10 = getCookiesConfig({
      forceOpen: forceOpenCookieAgreement,
      reloadOnSave: false,
      onSubmit: t9,
      onCookieTrackerEvent: handleCookieTrackerEvent
    });
    $[20] = forceOpenCookieAgreement;
    $[21] = handleCookieTrackerEvent;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== businessVariables || $[24] !== http || $[25] !== t10) {
    t11 = <CookieAgreements businessVariables={businessVariables} http={http} config={t10} />;
    $[23] = businessVariables;
    $[24] = http;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = getFooterConfig({
      handleAgreements: () => {
        setForceOpenCookieAgreement(true);
      }
    });
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== analyticsInstance || $[29] !== businessVariables) {
    t13 = <Footer config={t12} businessVariables={businessVariables} analytics={analyticsInstance} />;
    $[28] = analyticsInstance;
    $[29] = businessVariables;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t11 || $[32] !== t13 || $[33] !== t7 || $[34] !== t8) {
    t14 = <>{t7}{t8}{t11}{t13}</>;
    $[31] = t11;
    $[32] = t13;
    $[33] = t7;
    $[34] = t8;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
export default HomeContent;
function _temp() {}